/*
 * Created by mvasim on 12/9/17.
 */

/*
 * tableAction ->
 *  'ADD' -> Add Action
 *  'REFRESH' -> Refresh Action
 *
 */

import { Subject } from 'rxjs';

export interface TableAction {
  action: string;
  data: any;
}

export enum TABLE_ACTION_TYPE {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  REFRESH = 'REFRESH',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
}
export class FnTableConfig {
  static defalutSortClass = 'fn-global-sort';
  static defaultSortValue = 0; // -1 = desc , 1 = asc
  static defaultIsColSort = true;

  uniqueKey?: any;
  tableClass?: string;
  pagination? = true;
  filterOn? = true;
  hideAction? = false;
  hideEdit? = false;
  hideDelete? = false;
  defaultSortKey?: string;
  hidePagination?: boolean;
  isSelectable?: boolean;
  isCustomTemplate?: boolean;
  tableAction: Subject<TableAction>;
  showTblSearch? = false;
  showTblSearchAtStart? = false;
  tblSearchClass? = "right";
  showRowExpand?= false;
  rowExpandName?= 'dataArray';
}
